



















































































































































import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { PlaceholdersOnes, PlaceholdersStack } from '../../../../components/Editor/components/Toolbar/types'
import HighlightAnchor from '../../../../components/HighlightAnchor.vue'
import {
  AvailableButtonsTypes,
} from "../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import PageTitle from "../../../../components/PageTitle.vue";
import FieldTitle from '../../../../components/Pi/components/FieldTitle.vue'
import { SelectOptionData } from '../../../../components/Pi/types'
import { BindTargetByCode, BindTargetByCodeRes } from "../../../types/BindTarget.types";
import { VueComponent } from "../../../types/VueComponent";
import { UserActivationActionTypeEnum } from '../ActivationAction';
import ActivationActionData from '../ActivationAction/ActivationActionData.vue'
import { BotPmConfig } from '../types'

@Component({
  components: {
    HighlightAnchor,
    ActivationActionData,
    FieldTitle,
    PageTitle
  },
  data() {
    return {
      UserActivationActionTypeEnum
    }
  }
})
export default class PrivateMessageSettings extends Vue {
  @Prop() pmConfig!: BotPmConfig

  @Prop() board!: { title: string, board: string }

  @Prop() saveConfig!: (config: BotPmConfig) => Promise<void>

  @Prop() flowOptions!: Array<SelectOptionData>

  @Prop() emptyFlowButtonCallback!: () => void

  @Prop() getFlowPreview!: (key: string) => string

  @Prop() buttons!: Array<AvailableButtonsTypes>

  @Prop() editorButtonsHelpView!: VueComponent | string

  @Prop() adminList!: Array<SelectOptionData>

  @Prop() bindTargetByCode!: (args: BindTargetByCode) => Promise<BindTargetByCodeRes | void>

  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() limitTypes!: Array<UserActivationActionTypeEnum>

  @Watch('pmConfig', { deep: true })
  pmConfigWatcher(config: BotPmConfig): void {
    this.configCopy = cloneDeep(config)
  }

  configCopy: BotPmConfig | null = null

  saveConfigHandler(config: BotPmConfig) {
    return this.saveConfig(config)
  }

  unbindGroup(): Promise<void> {
    return new Promise(resolve => {
      if (this.configCopy) {
        this.configCopy.feedback_group_id = null

        this.saveConfigHandler(this.configCopy).then(() => resolve())
      }
    })
  }

  created(): void {
    this.configCopy = cloneDeep(this.pmConfig)
  }
}
